/*
  Single.js - Sent SMS Single Component
*/

// NPM MODULES
import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const ConfirmationDialog = ({
  showConfirmation,
  setShowConfirmation,
  message,
  handleCancelPendingMessage,
}) => {
  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <Dialog
      open={showConfirmation}
      onClose={handleCloseConfirmation}
      aria-labelledby="cancel-dialog-title"
      aria-describedby="cancel-dialog-description">
      <DialogTitle id="cancel-dialog-title" variant="h2">
        Cancellation Confirmation
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="cancel-dialog-description" variant="p">
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleCloseConfirmation}
          color="secondary"
          variant="outlined">
          No
        </Button>

        <Button
          onClick={handleCancelPendingMessage}
          color="secondary"
          variant="contained"
          autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
